import {Alert, Breadcrumb, Button, Col, Dropdown, Offcanvas, Row} from 'react-bootstrap'
import './soldStyles.css'
import {useEffect, useState, useRef} from 'react'
import {PolicyForm} from './components/PolicyForm'
import {DocumentsTab} from './components/DocumentsTab'
import {RemindersTab} from './components/RemindersTab'
import {useDisclourse} from '../../hooks/useDisclourse'
import {ModalNotes} from './components/ModalNotes'
import {Link, useLocation, useMatch, useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {useLazyQuery, useMutation, useQuery} from '@apollo/client'
import {
  GET_ONE_POLICY_ATTACHMENTS_API,
  GET_ONE_POLICY_BASE_API,
} from '../../gql/queries/policiesApiQueries'
import {
  IEdgesAttachments,
  IResOnePolicyApi,
  NodePolicy,
  NodeMemberPolicy,
  IResOneQuote,
} from '../../types/policiesApi'
import {toast} from 'react-toastify'
import {LoadingOnePolicy} from './components/LoadingOnePolicy'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {formatPhoneNumber, hasPermission, parseId, removeEmptyKeys} from '../../helpers'
import {UPDATE_POLICY_FULL} from '../../gql/mutations/policyMutation'
import {
  AllPolicyStatusesData,
  AllPolicyStatusesVars,
  IResUpdatePolicyFullApi,
} from '../../types/policies'
import {
  getMetalLevelValueByLabel,
  INIT_FORM_EXTRAS,
  INIT_FORM_MEMBERS,
  INIT_FORM_QUOTE_POLICY,
  INIT_FORMS_PAYMENTS,
  INIT_IFORM,
  normalizeAmount,
  STATUS_POLICY,
  ALL_PERMISSIONS,
  getPolicyCategory,
} from '../../helpers/consts'
import {ModalCancelPolicy} from './components/ModalCancelPolicy'
import {ModalCompletePolicy} from './components/ModalCompletePolicy'
import {HolderInfoSide} from './components/HolderInfoSide'
import {LastNotePreview} from './components/LastNotePreview'
import {ModalMemberIdPolicy} from './components/ModalMemberIdPolicy'
import {ActivityTab} from './components/ActivityTab'
import {PolicySummary} from './components/PolicySummary'
import {ListSectionSide} from './components/ListSectionSide'
import {TFormAllValues, TFormMemberPolicy, TFormPaymentsPolicy} from '../policies/policiesTypes'
import {ModalStatusesPolicy} from './components/ModalStatusesPolicy'
import {ConsentRequestTab} from './components/ConsentRequestTab'
import {GET_ALL_POLICIES_STATUSES} from '../../gql/queries/policiesQueries'
import {getColorByStatus, getTitleByStatus, mapNodeToFormikValues} from '../shared/utils'
import {
  GET_ONE_QUOTE_ATTACHMENTS,
  GET_ONE_QUOTE_BASE,
} from '../../gql/queries/newQuotesQuery'
import {SelectPlansDrawer} from './components/SelectPlansDrawer'
import {GET_STATES_EU} from '../../gql/queries/statesEUQuery'
import {IResStates} from '../../types/statesEU'
import {ModalToPolicy} from '../oneQuote/components/ModalToPolicy'
import {IForm} from '../oneAddQuote/oneQuoteTypes'
import {mapFormQuoteToQuoteData} from './utils-sold'
import {TFormTabsPolicy} from './soldTypes'
import {Plan} from '../oneLead/oneleadTypes'
import {GET_ALL_CARRIERS_LIST} from '../../gql/queries/carriersQuery'
import {IResCarriersList, IResGetOrCreateInsuranceOperator} from '../../types/carriers'
import {GET_OR_CREATE_INSURANCE_OPERATOR} from '../../gql/mutations/carriersMutations'
import {ModalAssignAgentPolicy} from './components/ModalAssignAgentPolicy'
import {ModalChangeSourcePolicy} from './components/ModalChangeSourcePolicy'
import {ModalDuplicatePolicy} from './components/ModalDuplicatePolicy'
import {useGetUser} from '../../store/userStore'
import {CommunicationsTab} from './components/CommunicationsTab'
import {PolicyTicketsTab} from './components/PolicyTicketsTab'
import {GET_TICKETS} from '../../gql/queries/ticketsQuery'
import {IResTickets} from '../../types/tickets'
import {useTelephony} from '../../hooks/useTelephony'
import {CommissionsTab} from './components/CommissionsTab'
import {ModalACAVerification} from './components/ModalACAVerification'
import {ACAVerificationsTab} from './components/ACAVerificationsTab'

const BASE_SECTIONS = [
  {name: 'Policy Form', icon: 'person-fill'},
  {name: 'Documents', icon: 'folder-fill'},
  {name: 'Notes', icon: 'pencil-square'},
  {name: 'Reminders', icon: 'arrow-repeat'},
  {name: 'Activity', icon: 'hourglass-split'},
  {name: 'Signature Forms', icon: 'vector-pen'},
  {name: 'Communications', icon: 'chat-left-text'},
] as const

const COMMISSIONS_SECTION = {name: 'Commissions', icon: 'cash-stack'} as const

const POLICY_TICKETS_SECTION = {name: 'Tickets', icon: 'ticket-perforated'} as const

const ACA_VERIFICATIONS_SECTION = {name: 'ACA Verifications', icon: 'clipboard2-check'} as const

export type TabsPolicy =
  | typeof BASE_SECTIONS[number]['name']
  | typeof COMMISSIONS_SECTION['name']
  | typeof POLICY_TICKETS_SECTION['name']
  | typeof ACA_VERIFICATIONS_SECTION['name']

export type Section = {
  name: TabsPolicy
  icon: string
  label?: string
}

export function cloneMember(isHolder: boolean = false): TFormMemberPolicy {
  const cloned = JSON.parse(JSON.stringify(INIT_FORM_MEMBERS))
  if (!isHolder) {
    cloned.rol = 'FAMILY'
  }
  return cloned
}

export function resetFormQuotePolicy(): TFormAllValues {
  return {
    ...JSON.parse(JSON.stringify(INIT_FORM_QUOTE_POLICY)),
    holder: cloneMember(true),
    policyMembers: [],
  }
}

const validationSchema = Yup.object().shape({
  holder: Yup.object({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    dateBirth: Yup.date().required('(required)'),
    gender: Yup.string().required('(required)'),
    phone: Yup.string().required('(required)'),
    //emailAddress: Yup.string().email('Invalid email'),
  }),
  zipCode: Yup.string().required('(required)'),
  applicants: Yup.number().required('(required)').min(0, 'Cannot be negative'),
  effectiveDate: Yup.date().required('(required)'),
  typePolicy: Yup.string().required('TypePolicy is required'),
  metalLevel: Yup.string().required('Required'),

  policyMembers: Yup.array().of(
    Yup.object().shape({
      firstName: Yup.string().required('First name is required'),
      lastName: Yup.string().required('Last name is required'),
      dateBirth: Yup.date().required('Date of birth is required'),
      gender: Yup.string().required('Gender is required'),
    })
  ),
})

const normalizeBoolean = (val: any): boolean => {
  if (typeof val === 'string') {
    return val.toLowerCase() === 'true'
  }
  return Boolean(val)
}

const normalizeNullableBoolean = (val: any): boolean | null => {
  if (val === null || val === undefined || val === '') return null
  if (typeof val === 'string') return val.toLowerCase() === 'true'
  return Boolean(val)
}

const buildMembersToUpdateClean = (values: TFormAllValues) => {
  const cleanMember = (member: TFormMemberPolicy) => {
    if (!member.id) return null

    const {id, usesTobacco, isPregnant, applicant, ...rest} = member
    const cleaned = Object.fromEntries(
      Object.entries(rest).filter(([_, value]) => value !== null && value !== '0')
    )

    return {
      id: parseId(id),
      ...cleaned,
      usesTobacco: normalizeBoolean(usesTobacco),
      isPregnant: normalizeBoolean(isPregnant),
      applicant: member.applicant,
      annualIncome1: normalizeAmount(member.annualIncome1),
      annualIncome2: normalizeAmount(member.annualIncome2),
      annualIncome3: normalizeAmount(member.annualIncome3),
    }
  }

  const holder = cleanMember(values.holder)
  const others = values.policyMembers
    .map(cleanMember)
    .filter((m): m is {id: string; [key: string]: any} => m !== null)

  return holder ? [holder, ...others] : others
}

const toId = (obj?: {id: string | number} | null) => (obj?.id ? obj.id : null)
const isObject = (val: any) => val && typeof val === 'object' && !Array.isArray(val)

const buildPolicyDataClean = (values: TFormAllValues) => {
  // Campos obligatorios que siempre deben enviarse (enums, fechas, booleans esenciales)
  const required = {
    stateDocs: values.stateDocs,
    paymentStatus: values.paymentStatus,
    status: values.status,
    effectiveDate: values.effectiveDate || null,
    isImportant: !!values.isImportant,
    commissionPayable: !!values.commissionPayable,
    ownsCar: normalizeNullableBoolean(values.ownsCar),
    ownsHome: normalizeNullableBoolean(values.ownsHome),
    hasAutoPolicy: normalizeNullableBoolean(values.hasAutoPolicy),
    hasHomePolicy: normalizeNullableBoolean(values.hasHomePolicy),
  }

  // Campos opcionales que pueden omitirse si están vacíos
  const optional = {
    policyName: values.policyName,
    applicants: Number(values.applicants),
    members: Number(values.members),
    dependents: Number(values.dependents),
    planName: values.planName,
    metalLevel: values.metalLevel === '' ? null : Number(values.metalLevel),
    policyTotalCost: values.policyTotalCost,
    taxCredit: values.taxCredit,
    premium: values.premium,
    marketplaceId: values.marketplaceId,
    memberId: values.memberId,
    CMSPlanId: values.CMSPlanId,
    FFM: values.FFM,
    NPN: values.NPN,
    typeSale: values.typeSale,
    carrier: parseId(values.carrier),
    typePolicy: parseId(values.typePolicy),
    city: values.city,
    zipCode: values.zipCode,
    address1: values.address1,
    address2: values.address2,
    countyFips: values.countyFips,
    stateEU: parseId(toId(values.stateEU) ?? ''),

    mailingAddress1: values.mailingAddress1,
    mailingAddress2: values.mailingAddress2,
    mailingCity: values.mailingCity,
    mailingZipCode: values.mailingZipCode,
    mailingCountyFips: values.mailingCountyFips,
    mailingStateEU: parseId(toId(values.mailingStateEU) ?? ''),

    completedDate: values.completedDate || null,
    canceledDate: values.canceledDate || null,
    archivedDate: values.archivedDate || null,
    lead: toId(values.lead),
    assignedTo: toId(values.assignedTo),
  }

  const cleanedOptional = Object.fromEntries(
    Object.entries(optional).filter(([_, v]) =>
      typeof v === 'object'
        ? v !== null && 'id' in v // conserva objetos con id
        : v !== undefined && v !== null
    )
  )

  return {
    ...required,
    ...cleanedOptional,
  }
}
const buildUpdatePolicyVariables = (values: TFormAllValues) => {
  // console.log('isObject(values.policyPayment)', isObject(values.policyExtraInfo))
  return {
    id: values.id,
    policyData: buildPolicyDataClean(values),
    membersToCreate: getMembersToCreate(values),
    membersToUpdate: buildMembersToUpdateClean(values),
    membersToDelete: values.policyMembersDelete || [],
    paymentData: buildPolicyPaymentClean(values.policyPayment),
    extraInfoData: isObject(values.policyExtraInfo) ? values.policyExtraInfo : null,
  }
}
const buildPolicyPaymentClean = (payment: TFormPaymentsPolicy) => {
  const cleaned = Object.fromEntries(
    Object.entries(payment).filter(([_, value]) => value !== '' && value !== null)
  )

  const result: any = {
    ...cleaned,
    recurrentPayment: Boolean(payment.recurrentPayment),
    bankAccount: Boolean(payment.bankAccount),
  }

  // Asegúrate de extraer el ID base64 directamente desde payment.stateEU.id
  const rawId = typeof payment.stateEU === 'object' ? payment.stateEU?.id : payment.stateEU
  const parsedId = parseId(rawId)

  if (parsedId && parsedId !== '0') {
    result.stateEU = parsedId
  }

  return result
}
const getMembersToCreate = (values: TFormAllValues) => {
  return values.policyMembers
    .filter((member) => !member.id) // solo sin ID
    .map(({id, member, ...rest}) => ({
      ...rest,
      annualIncome1: normalizeAmount(rest.annualIncome1),
      annualIncome2: normalizeAmount(rest.annualIncome2),
      annualIncome3: normalizeAmount(rest.annualIncome3),
    }))
}

export const OnePolicyPage = () => {
  const permissions = useGetUser((s) => s.user?.permissions)
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const telephony = useTelephony()

  const canMarkAsCompleted =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.MARK_COMPLETED_POLICY)
  const canViewCommissions =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION)
  const canAddACAVerification =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.ADD_ACA_VERIFICATION)
  const canChangeACAVerification =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.CHANGE_ACA_VERIFICATION)

  const {id} = useParams()

  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const lead = searchParams.get('lead')

  const isQuote = useMatch('/one-quote/:id')
  const isPolicy = useMatch('/one-policy/:id')
  const isSold = useMatch('/sold/:id')

  let tipo: 'quote' | 'policy' | 'sold' | undefined
  if (isQuote) tipo = 'quote'
  else if (isPolicy) tipo = 'policy'
  else if (isSold) tipo = 'sold'

  const {data: policyTicketsCountData} = useQuery<IResTickets>(GET_TICKETS, {
    variables: {
      policyId: id ? parseId(id) : undefined,
      first: 1,
      offset: 0,
      includeArchived: true,
    },
    skip: !(id && (isPolicy || isSold)),
    fetchPolicy: 'no-cache',
  })

  const policyTicketsCount = policyTicketsCountData?.tickets?.totalCount || 0

  const {data: openTicketsData} = useQuery<IResTickets>(GET_TICKETS, {
    variables: {
      policyId: id ? parseId(id) : undefined,
      first: 1,
      offset: 0,
      includeArchived: false,
      includeSolvedClosed: false,
    },
    skip: !(id && (isPolicy || isSold)),
    fetchPolicy: 'no-cache',
  })

  const hasOpenTickets = (openTicketsData?.tickets?.totalCount || 0) > 0

  // sections is computed below, after `data` state is declared, so isACAPolicy can be included

  const {data: dataStates, error: errorStates} = useQuery<IResStates>(GET_STATES_EU)

  const [gqlGetCarriers, {data: dataCarriers, loading: loadingCarriers, error: errorCarriers}] =
    useLazyQuery<IResCarriersList>(GET_ALL_CARRIERS_LIST, {fetchPolicy: 'no-cache'})

  useEffect(() => {
    gqlGetCarriers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataStates])

  useEffect(() => {
    if (errorCarriers) toast.error(`Error: ${errorCarriers.message}`)
  }, [errorCarriers])

  const {
    data: dataPoliciesStatuses,
    loading: loadingPoliciesStatus,
    error: errorPoliciesStatuses,
  } = useQuery<AllPolicyStatusesData, AllPolicyStatusesVars>(GET_ALL_POLICIES_STATUSES, {
    fetchPolicy: 'cache-first',
  })

  const [gqlUpdatePoliciFull, {data: dataUpdate, loading: loadingUpdate, error: errorUpdate}] =
    useMutation<IResUpdatePolicyFullApi>(UPDATE_POLICY_FULL)

  const [
    gqlGetPolicy,
    {data: dataPolicy, loading: loadingPolicy, error: errorPolicy, refetch: refetchPolicy},
  ] = useLazyQuery<IResOnePolicyApi>(GET_ONE_POLICY_BASE_API, {fetchPolicy: 'no-cache'})

  const [
    gqlGetQuote,
    {data: dataQuote, loading: loadingQuote, error: errorQuote, refetch: refetchQuote},
  ] = useLazyQuery<IResOneQuote>(GET_ONE_QUOTE_BASE, {fetchPolicy: 'no-cache'})

  const [
    gqlGetPolicyAttachments,
    {
      data: dataPolicyAttachments,
      error: errorPolicyAttachments,
    },
  ] = useLazyQuery<IResOnePolicyApi>(GET_ONE_POLICY_ATTACHMENTS_API, {fetchPolicy: 'no-cache'})

  const [
    gqlGetQuoteAttachments,
    {
      data: dataQuoteAttachments,
      error: errorQuoteAttachments,
    },
  ] = useLazyQuery<IResOneQuote>(GET_ONE_QUOTE_ATTACHMENTS, {fetchPolicy: 'no-cache'})

  // Refetch helper that routes to the correct query (policy vs quote) and always includes id
  const refetchCurrent = (vars?: {id?: string | number}) => {
    const routeId = id
    const desiredId = vars?.id ?? routeId
    const finalId = desiredId ? String(desiredId) : undefined

    if (!finalId) {
      console.error('[refetchCurrent] Missing id. vars:', vars, 'routeId:', routeId)
      toast.error('Missing id to refetch')
      return Promise.resolve(undefined)
    }

    if (isQuote) {
      console.log('[refetchCurrent] Refetching QUOTE with id =', finalId)
      return refetchQuote({id: finalId})
    }
    if (isPolicy) {
      console.log('[refetchCurrent] Refetching POLICY with id =', finalId)
      return refetchPolicy({id: finalId})
    }
    // Fallback: try policy
    console.warn(
      '[refetchCurrent] Unknown route type, defaulting to POLICY refetch with id =',
      finalId
    )
    return refetchPolicy({id: finalId})
  }

  const [gqlGetOrCreateOperator, {data: dataSetPlanCarrier}] =
    useMutation<IResGetOrCreateInsuranceOperator>(GET_OR_CREATE_INSURANCE_OPERATOR)

  const [data, setData] = useState<NodePolicy | undefined | 'not-found'>()

  const isACAPolicy =
    !!data &&
    data !== 'not-found' &&
    (data as NodePolicy).typePolicy?.typePolicy?.toLowerCase() === 'aca'

  const sections: readonly Section[] = (isPolicy || isSold)
    ? [
        ...BASE_SECTIONS,
        ...(isACAPolicy ? [ACA_VERIFICATIONS_SECTION] : []),
        COMMISSIONS_SECTION,
        {
          ...POLICY_TICKETS_SECTION,
          label: `Tickets (${policyTicketsCount})`,
        },
      ]
    : [
        ...BASE_SECTIONS,
        COMMISSIONS_SECTION,
      ]

  const [typeAssign, setTypeAssign] = useState<'ASSIGN_TO' | 'USER_TO'>('ASSIGN_TO')
  const [holderPolicy, setHolderPolicy] = useState<undefined | NodeMemberPolicy>()
  const [documents, setDocuments] = useState<IEdgesAttachments[]>([])

  const [tabs, setTabs] = useState<TabsPolicy>((searchParams.get('tab') as TabsPolicy) || 'Policy Form')
  const {isOpen: isOpenNotes, onOpen: onOpenNotes, onClose: onCloseNotes} = useDisclourse()
  const {isOpen: isOpenCancel, onOpen: onOpenCancel, onClose: onCloseCancel} = useDisclourse()
  const {isOpen: isOpenComplete, onOpen: onOpenComplete, onClose: onCloseComplete} = useDisclourse()
  const {isOpen: isOpenMemberId, onOpen: onOpenMemberId, onClose: onCloseMemberId} = useDisclourse()
  const {isOpen: isOpenStatuses, onOpen: onOpenStatuses, onClose: onCloseStatuses} = useDisclourse()
  const {isOpen: isOpenDrawer, onClose: onCloseDrawer, onOpen: onOpenDrawer} = useDisclourse()
  const {isOpen: isOpenToPolicy, onOpen: onOpenToPolicy, onClose: onCloseToPolicy} = useDisclourse()
  const {
    isOpen: isOpenAssignPolicy,
    onOpen: onOpenAssignPolicy,
    onClose: onCloseAssignPolicy,
  } = useDisclourse()
  const {
    isOpen: isOpenChangeSource,
    onOpen: onOpenChangeSource,
    onClose: onCloseChangeSource,
  } = useDisclourse()
  const {isOpen: isOpenDuplicate, onOpen: onOpenDuplicate, onClose: onCloseDuplicate} = useDisclourse()
  const {isOpen: isOpenACAVerification, onOpen: onOpenACAVerification, onClose: onCloseACAVerification} = useDisclourse()

  const [show, setShow] = useState(false)
  const [updateZips, setUpdateZips] = useState(0)
  const [quoteData, setQuoteData] = useState<IForm>({...INIT_IFORM})
  const [tabsPolicy, setFormTabsPolicy] = useState<TFormTabsPolicy>('policy-holder')

  const category = getPolicyCategory(
    dataPoliciesStatuses?.allPolicyStatuses?.edges,
    dataPolicy?.policiesById?.status
  )
  const canSwitchHolderByRole =
    userGroups.includes('Agente') ||
    userGroups.includes('Supervisor') ||
    userGroups.includes('Administrador') ||
    userGroups.includes('SuperAdministrador')
  const isPolicyNode = !!data && data !== 'not-found'
  const canShowSwitchHolder =
    !!isQuote ||
    (isPolicyNode &&
      data.type === 'POLICY' &&
      category === STATUS_POLICY.COMPLETED &&
      canSwitchHolderByRole)

  // Controlled Save state
  const [isSaving, setIsSaving] = useState(false)


  const formik = useFormik<TFormAllValues>({
    validationSchema: validationSchema,
    initialValues: resetFormQuotePolicy(),
    onSubmit: (v) => {
      // console.log('Input values in Submit', v)
      const variables = removeEmptyKeys(buildUpdatePolicyVariables(v))
      // console.log('Submit POST buildUpdatePolicyVariables', variables)
      gqlUpdatePoliciFull({variables})
    },
  })

  useEffect(() => {
    if (errorStates) toast.error(`Error: ${errorStates.message}`)
  }, [errorStates])

  useEffect(() => {
    if (Number(lead)) {
      formik.setFieldValue('lead', lead)
      setData({} as NodePolicy)
      navigate(`/lead/${lead}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lead])

  useEffect(() => {
    if (Number(id)) {
      if (isPolicy) {
        gqlGetPolicy({
          variables: {
            id: id,
          },
        })
      }
      if (isQuote) {
        gqlGetQuote({
          variables: {
            id: id,
          },
        })
      }
    }
  }, [gqlGetPolicy, gqlGetQuote, id, isPolicy, isQuote, tipo])

  useEffect(() => {
    if (errorPolicy) toast.error(`Error: ${errorPolicy.message}`)
  }, [errorPolicy])

  useEffect(() => {
    if (errorQuote) toast.error(`Error: ${errorQuote.message}`)
  }, [errorQuote])

  useEffect(() => {
    if (errorPolicyAttachments) toast.error(`Error: ${errorPolicyAttachments.message}`)
  }, [errorPolicyAttachments])

  useEffect(() => {
    if (errorQuoteAttachments) toast.error(`Error: ${errorQuoteAttachments.message}`)
  }, [errorQuoteAttachments])

  useEffect(() => {
    if (errorPoliciesStatuses)
      toast.error(`Error getting status policy: ${errorPoliciesStatuses.message}`)
  }, [errorPoliciesStatuses])

  function setDataPolicy(dataQuotePolicy) {
    setData(dataQuotePolicy || 'not-found')

    const formikValues = mapNodeToFormikValues(
      dataQuotePolicy, // objeto recibido del backend
      INIT_FORM_QUOTE_POLICY, // tu plantilla base
      {
        // campos especiales con lógica personalizada
        stateEU: (val) => ({
          id: parseId(val?.id),
          code: val?.code ?? '',
          name: val?.name ?? '',
        }),
        mailingStateeu: (val) => ({
          id: parseId(val?.id),
          code: val?.code ?? '',
          name: val?.name ?? '',
        }),
        user: (val) => ({id: parseId(val?.id)}),
        // typePolicy: (val) => ({id: toId(val?.id)}),
        // carrier: (val) => ({id: (val?.id)}),
        assignedTo: (val) => ({id: parseId(val?.id)}),
        policyPayment: (val) => mapNodeToFormikValues(val ?? {}, INIT_FORMS_PAYMENTS),
        policyExtraInfo: (val) => mapNodeToFormikValues(val ?? {}, INIT_FORM_EXTRAS),
      }
    )
    const holderNode = dataQuotePolicy.memberPolicySet?.edges?.find(
      ({node}) => node.rol === 'HOLDER'
    )?.node
    if (holderNode) {
      console.log('HOLDER NODE FROM API:', holderNode); formikValues.holder = mapNodeToFormikValues(holderNode, INIT_FORM_MEMBERS); console.log('MAPPED HOLDER:', formikValues.holder);
      setHolderPolicy(holderNode)
    }
    const members =
      dataQuotePolicy.memberPolicySet?.edges
        ?.filter(({node}) => node.rol !== 'HOLDER')
        ?.map(({node}) => mapNodeToFormikValues(node, INIT_FORM_MEMBERS)) || []
    formikValues.policyMembers = members

    if (!formikValues.policyExtraInfo?.cancellationDate && dataQuotePolicy?.canceledDate) {
      if (!formikValues.policyExtraInfo) formikValues.policyExtraInfo = { ...INIT_FORM_EXTRAS }
      formikValues.policyExtraInfo.cancellationDate = dataQuotePolicy.canceledDate
    }

    formik.setValues(formikValues)
  }

  useEffect(() => {
    if (!dataSetPlanCarrier?.getOrCreateInsuranceOperatorByName.success) return
    const carrierMut = dataSetPlanCarrier?.getOrCreateInsuranceOperatorByName.insuranceOperatorId
    if (!dataCarriers || !carrierMut) return

    const carrierMutStr = String(carrierMut)
    const newCarr = dataCarriers.allInsuranceOperatorsList.find(
      (carrier) =>
        String(carrier.id) === carrierMutStr ||
        String(parseId(carrier.id)) === String(parseId(carrierMutStr))
    )

    if (newCarr?.id) {
      formik.setFieldValue('carrier', newCarr.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSetPlanCarrier, dataCarriers])

  useEffect(() => {
    if (!dataPolicy?.policiesById) return
    setUpdateZips(updateZips + 1)
    const {policiesById} = dataPolicy
    setDataPolicy(policiesById)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataPolicy])

  useEffect(() => {
    if (!dataQuote?.quotesById) return
    setUpdateZips(updateZips + 1)
    const {quotesById} = dataQuote
    setDataPolicy(quotesById)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataQuote])

  useEffect(() => {
    if (errorUpdate) {
      toast.error(`Error: ${errorUpdate.message}`)
    }
  }, [errorUpdate])

  useEffect(() => {
    if (!dataPolicyAttachments?.policiesById?.policyAttachmentsSet?.edges) return
    setDocuments(dataPolicyAttachments.policiesById.policyAttachmentsSet.edges)
  }, [dataPolicyAttachments])

  useEffect(() => {
    if (!dataQuoteAttachments?.quotesById?.policyAttachmentsSet?.edges) return
    setDocuments(dataQuoteAttachments.quotesById.policyAttachmentsSet.edges)
  }, [dataQuoteAttachments])

  useEffect(() => {
    if (!dataUpdate) return
    if (dataUpdate.updatePolicyFull?.success) {
      if (isPolicy) toast.success('Policy Updated successfully')
      if (isQuote) toast.success('Quote Updated successfully')
      setTabs('Policy Form')
      console.log('updatePolicyFull:')
      if (dataUpdate.updatePolicyFull?.policy) {
        setUpdateZips(updateZips + 1)
        setDataPolicy(dataUpdate.updatePolicyFull?.policy)
      }
    } else if (dataUpdate.updatePolicyFull?.errors?.length > 0) {
      toast.error(`Error: ${dataUpdate.updatePolicyFull.errors[0]?.message || 'Something wrong'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdate])

  const handleChange = (field: string, value: any) => {
    formik.setFieldValue(field, value)
    console.log('Cambiando campo:', field, value)
  }

  const handleBlur = (field: string) => {
    formik.setFieldTouched(field, true)
  }

  const handleSubmit = () => {
    formik.handleSubmit()
  }

  const loadDocuments = (vars?: {id?: string | number}) => {
    const routeId = id
    const desiredId = vars?.id ?? routeId
    const finalId = desiredId ? String(desiredId) : undefined

    if (!finalId) {
      toast.error('Missing id to fetch documents')
      return Promise.resolve(undefined)
    }

    if (isQuote) {
      return gqlGetQuoteAttachments({variables: {id: finalId}})
    }

    if (isPolicy) {
      return gqlGetPolicyAttachments({variables: {id: finalId}})
    }

    return Promise.resolve(undefined)
  }

  useEffect(() => {
    setDocuments([])
  }, [id, isPolicy, isQuote])

  useEffect(() => {
    if (tabs !== 'Documents' || !id) return
    loadDocuments({id})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs, id, isPolicy, isQuote])

  // --- Helpers (puedes ponerlos arriba de handleSave) ---
  const fieldLabels: Record<string, string> = {
    zipCode: 'Zip code',
    applicants: 'Applicants',
    effectiveDate: 'Effective date',
    typePolicy: 'Type of policy',
    metalLevel: 'Metal level',

    'holder.firstName': 'Holder · First name',
    'holder.lastName': 'Holder · Last name',
    'holder.dateBirth': 'Holder · Date of birth',
    'holder.gender': 'Holder · Gender',
    'holder.phone': 'Holder · Phone',
    'holder.emailAddress': 'Holder · Email',
  }

  const pickFormTabByPath = (path: string): TFormTabsPolicy => {
    if (path.startsWith('holder')) return 'policy-holder'
    if (path.startsWith('policyMembers')) return 'members'
    if (path.startsWith('policyPayment')) return 'payment'
    if (path.startsWith('policyExtraInfo')) return 'extras'
    return 'policy-insurance'
  }

  const prettyLabelForPath = (path: string): string => {
    if (fieldLabels[path]) return fieldLabels[path]

    // policyMembers[0].firstName -> "Member #1 · first name"
    const m = path.match(/^policyMembers\[(\d+)\]\.(.+)$/)
    if (m) {
      const idx = Number(m[1]) + 1
      const field = m[2]
      const base =
        fieldLabels[`policyMembers.${field}`] || field.replace(/([A-Z])/g, ' $1').toLowerCase()
      return `Member #${idx} · ${base}`
    }

    if (path.startsWith('holder.')) {
      const field = path.split('.').slice(1).join('.')
      const base = fieldLabels[`holder.${field}`] || field.replace(/([A-Z])/g, ' $1').toLowerCase()
      return `Holder · ${base}`
    }

    return path.replace(/([A-Z])/g, ' $1')
  }

  // DFS para hallar la primera ruta de error: 'holder.firstName', 'policyMembers[0].dateBirth', etc.
  const findFirstErrorPath = (err: any, prefix = ''): string | null => {
    if (!err) return null
    if (Array.isArray(err)) {
      for (let i = 0; i < err.length; i++) {
        const child = err[i]
        const p = prefix ? `${prefix}[${i}]` : `[${i}]`
        const found = findFirstErrorPath(child, p)
        if (found) return found
      }
      return null
    }
    if (typeof err === 'object') {
      for (const key of Object.keys(err)) {
        const child = err[key]
        const p = prefix ? `${prefix}.${key}` : key
        const found = findFirstErrorPath(child, p)
        if (found) return found
      }
      return null
    }
    return prefix || null
  }

  // Controlled Save flow: validate, show toast errors, then call mutation
  const handleSave = async () => {
    try {
      setIsSaving(true)

      // 1) Validar con Formik y mostrar el primer error encontrado
      const errors = await formik.validateForm()
      if (errors && Object.keys(errors).length > 0) {
        // Localiza el campo más relevante
        const firstPath = findFirstErrorPath(errors) || ''

        // Casos comunes con mensaje y tab directo
        if (errors.holder) {
          setTabs('Policy Form')
          setFormTabsPolicy('policy-holder') // 👈 navega al tab interno
          const lbl = firstPath ? prettyLabelForPath(firstPath) : 'Holder information'
          toast.warn(`${lbl}: please complete this field before saving`)
          if (firstPath) formik.setFieldTouched(firstPath, true, false)
          return
        }
        if (errors.policyMembers) {
          setTabs('Policy Form')
          setFormTabsPolicy('members')
          const lbl = firstPath ? prettyLabelForPath(firstPath) : 'Members information'
          toast.warn(`${lbl}: please complete this field before saving`)
          if (firstPath) formik.setFieldTouched(firstPath, true, false)
          return
        }

        // Genérico: decide tab por la ruta del error
        const tab = pickFormTabByPath(firstPath)
        setTabs('Policy Form')
        setFormTabsPolicy(tab)
        const lbl = firstPath ? prettyLabelForPath(firstPath) : 'Required fields'
        toast.warn(`${lbl}: please complete this field before saving`)
        if (firstPath) formik.setFieldTouched(firstPath, true, false)
        return
      }
      // 2) Construir variables y ejecutar mutación
      const variables = removeEmptyKeys(buildUpdatePolicyVariables(formik.values))
      await gqlUpdatePoliciFull({variables})
      // El manejo post-execución ya existe en el useEffect de dataUpdate
    } catch (e: any) {
      toast.error(`Save failed: ${e?.message || 'Unknown error'}`)
    } finally {
      setIsSaving(false)
    }
  }

  const handleSearchPlan = () => {
    const vars = mapFormQuoteToQuoteData(formik.values, dataStates)
    const validGenders = ['Male', 'Female']

    const requiredFields = [
      vars.householdIncome,
      vars.countyfips,
      vars.personOne?.dob,
      vars.personOne?.age,
      vars.state,
      vars.zipCode,
    ]

    const allFieldsValid = requiredFields.every(
      (val) => val !== null && val !== undefined && val !== ''
    )

    const isGenderValid = validGenders.includes(vars.personOne?.gender)

    if (!allFieldsValid) {
      toast.warn(
        'Please complete all required fields before searching for plans. (HouseHold Income, ZipCode, Date of birth)'
      )
      return
    }

    if (!isGenderValid) {
      toast.warn('Please select a valid gender (Male or Female).')
      return
    }

    setQuoteData(vars)
    onOpenDrawer()
  }

  const handleSelectPlan = (plan: Plan) => {
    console.log('PLAN APLICADO', plan)
    const vals: TFormAllValues = formik.values
    vals.CMSPlanId = plan.id
    vals.planName = plan.name
    vals.metalLevel = getMetalLevelValueByLabel(plan.metal_level)
    vals.premium = plan.premium_w_credit
    vals.taxCredit = plan.premium - plan.premium_w_credit
    vals.policyTotalCost = plan.premium
    gqlGetOrCreateOperator({variables: {name: plan.issuer.name}})
    gqlGetCarriers()
    onCloseDrawer()
    setFormTabsPolicy('policy-insurance')
  }

  const addPolicyMember = () => {
    formik.setFieldValue('policyMembers', [...formik.values.policyMembers, cloneMember()])
  }
  const removePolicyMember = (index: number) => {
    const removed = formik.values.policyMembers[index]
    const updated = [...formik.values.policyMembers]
    updated.splice(index, 1)
    formik.setFieldValue('policyMembers', updated)

    if (removed.id) {
      const existing = formik.values.policyMembersDelete || []
      const parsedId = '' + parseId(removed.id) // 👈 aplica aquí el parseId
      if (!existing.includes(parsedId)) {
        formik.setFieldValue('policyMembersDelete', [...existing, parsedId])
      }
    }
  }

  const onSwitchWithHolder = (index: number) => {
    const selectedMember = {...formik.values.policyMembers[index]}
    const currentHolder = {...formik.values.holder}

    const newHolder = {...selectedMember, rol: 'HOLDER'}
    const newMember = {...currentHolder, rol: 'FAMILY'}

    // Aplica los cambios
    formik.setFieldValue('holder', newHolder)
    formik.setFieldValue(`policyMembers[${index}]`, newMember)

    toast.info(`Switched ${selectedMember.firstName} ${selectedMember.lastName} with policy holder`)
  }

  // --- LastNotePreview ref for refreshing notes ---
  const lastNoteRef = useRef<{ refetchNotes: () => void }>(null)

  if (loadingPolicy || loadingQuote || !data) {
    return <LoadingOnePolicy />
  }

  if (data === 'not-found') {
    return <div>Not found Policy</div>
  }

  const sendCall = async (phone: string) => {
    await telephony.startCall({
      phone: formatPhoneNumber(phone ?? ''),
      leadId: data.lead?.id ? parseId(data.lead.id) : null,
    })
  }

  return (
    <div>
      <header className='sold-policy-header'>
        <div>
          <Breadcrumb>
            <Breadcrumb.Item className='d-blok d-md-none' onClick={() => setShow(true)}>
              <span>
                <i className='bi bi-list fs-1' />
              </span>
            </Breadcrumb.Item>
            {isPolicy ? (
              <Breadcrumb.Item onClick={(e) => navigate('/policies')}>Policies</Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item onClick={(e) => navigate('/quotes')}>Quotes</Breadcrumb.Item>
            )}
            <Breadcrumb.Item active>{tabs}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className='buttons'>
          {tabs === 'Policy Form' && (
            <>
              {holderPolicy?.phone &&
                (telephony.config.provider === 'VICIDIAL' || telephony.isRingCentralConnected) && (
                <Button
                  size='sm'
                  variant='success'
                  onClick={() => {
                    sendCall(formatPhoneNumber(holderPolicy.phone))
                  }}
                >
                  <i className='bi bi-phone fs-3' /> Call Holder
                </Button>
              )}
              {isACAPolicy && canAddACAVerification && (
                <Button
                  size='sm'
                  variant='primary'
                  onClick={onOpenACAVerification}
                >
                  <i className='bi bi-clipboard2-check fs-3' /> ACA Verification
                </Button>
              )}
              <Button
                size='sm'
                variant='secondary'
                onClick={() => {
                  handleSearchPlan()
                }}
              >
                <i className='bi bi-search fs-3' /> Search Plan
              </Button>

              <Button
                size='sm'
                variant='info'
                onClick={handleSave}
                disabled={isSaving || loadingUpdate}
              >
                <i className='bi bi-save fs-3' /> {isSaving ? 'Saving...' : 'Save'}
              </Button>
            </>
          )}
          <Dropdown>
            <Dropdown.Toggle variant='primary' size='sm' id='dropdown-basic'>
              Options
            </Dropdown.Toggle>
            {isQuote && (
              <Dropdown.Menu>
                <Dropdown.Item
                  disabled={data.status !== 'QUOTED'}
                  onClick={() => {
                    onOpenToPolicy()
                  }}
                >
                  <span className='d-flex align-items-center gap-2'>
                    <i className='bi bi-arrow-up-right-circle fs-2' style={{color: 'green'}} />
                    <span>Convert to Policy</span>
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    onOpenNotes()
                  }}
                >
                  <span className='d-flex align-items-center gap-2'>
                    <i className='bi bi-pencil-square fs-2' />
                    <span>Add Notes</span>
                  </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            )}
            {isPolicy && (
              <Dropdown.Menu>
                {canMarkAsCompleted &&
                  category !== STATUS_POLICY.COMPLETED &&
                  category !== STATUS_POLICY.CANCELED && (
                    <Dropdown.Item
                      disabled={category !== STATUS_POLICY.PENDING}
                      onClick={() => {
                        onOpenComplete()
                      }}
                    >
                      <span className='d-flex align-items-center gap-2'>
                        <i className='bi bi-check-circle-fill fs-2' style={{color: 'green'}} />
                        <span>Mark as Completed</span>
                      </span>
                    </Dropdown.Item>
                  )}
                {category !== STATUS_POLICY.COMPLETED && category !== STATUS_POLICY.CANCELED ? (
                  <Dropdown.Item
                    onClick={() => {
                      onOpenCancel()
                    }}
                  >
                    <span className='d-flex align-items-center gap-2'>
                      <i className='bi bi-x-circle-fill fs-2' style={{color: 'red'}} />
                      <span>Cancel policy</span>
                    </span>
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item
                    onClick={() => {
                      onOpenStatuses()
                    }}
                  >
                    <span className='d-flex align-items-center gap-2'>
                      <i className='bi bi-arrow-left-right fs-2' style={{color: 'orange'}} />
                      <span>Update status</span>
                    </span>
                  </Dropdown.Item>
                )}
                <Dropdown.Item
                  onClick={() => {
                    onOpenMemberId()
                  }}
                >
                  <span className='d-flex align-items-center gap-2'>
                    <i className='bi bi-person-fill-up fs-2' style={{color: 'purple'}} />
                    <span>{data.memberId ? 'Edit' : 'Add'} Member ID</span>
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    setTypeAssign('ASSIGN_TO')
                    onOpenAssignPolicy()
                  }}
                >
                  <span className='d-flex align-items-center gap-2'>
                    <i className='bi bi-person-bounding-box fs-3' style={{color: 'purple'}} />
                    <span>Assign Policy</span>
                  </span>
                </Dropdown.Item>
                <Dropdown.Item onClick={onOpenDuplicate}>
                  <span className='d-flex align-items-center gap-2'>
                    <i className='bi bi-files fs-2' style={{color: 'blue'}} />
                    <span>Duplicate Policy</span>
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    const params = new URLSearchParams(location.search)
                    params.set('tab', 'Tickets')
                    const returnTo = encodeURIComponent(`${location.pathname}?${params.toString()}`)
                    navigate(`/tickets/new?policyId=${parseId(data.id)}&returnTo=${returnTo}`)
                  }}
                >
                  <span className='d-flex align-items-center gap-2'>
                    <i className='bi bi-ticket-perforated fs-2' style={{color: '#0d6efd'}} />
                    <span>Add Ticket</span>
                  </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            )}
          </Dropdown>
        </div>
      </header>
      {(lead || data.lead?.id) && (
        <div>
          <Alert>
            This policy originates from a lead.{' '}
            <Link
              to={`/lead/${lead ? lead : data.lead?.id ? parseId(data.lead.id) : '0'}`}
              style={{textDecoration: 'underline'}}
              target='_blank'
            >
              Click here
            </Link>{' '}
            for more information about the lead.
          </Alert>
        </div>
      )}
      <div className='mt-4'>
        <Row>
          <Col md={4} lg={4} sm={0} xl={3} className='d-none d-md-block'>
            <div className='menu-aside'>
              <div className='kt-widget__content pt-0'>
                <PolicySummary
                  assignAgent={onOpenAssignPolicy}
                  changeSource={onOpenChangeSource}
                  updateStatuses={onOpenStatuses}
                  setTypeAssign={setTypeAssign}
                  policy={`${id}`}
                  data={{
                    ...data,
                    status: getTitleByStatus(
                      dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
                      data.status
                    ),
                    color: getColorByStatus(
                      dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
                      data.status
                    ),
                  }}
                  isQuote={isQuote ? true : false}
                  category={category}
                />
                <HolderInfoSide
                  members={data.memberPolicySet.edges}
                  memberId={data.memberId}
                  zipCode={data.zipCode}
                  stateName={data.stateEU?.name}
                  stateCode={data.stateEU?.code}
                  countyFips={data.countyFips || data.mailingCountyFips}
                />
              </div>
              <ListSectionSide
                sections={sections}
                tabs={tabs}
                setTabs={setTabs}
                lead={lead}
                onOpenNotes={onOpenNotes}
              />
              {data.id && <LastNotePreview ref={lastNoteRef} idPolicy={data.id} />}
            </div>
          </Col>
          <Col md={8} lg={8} sm={12} xl={9}>
            {tabs === 'Policy Form' && (
              <PolicyForm
                values={formik.values}
                errors={formik.errors}
                touched={formik.touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleSubmit={handleSubmit}
                addMember={addPolicyMember}
                removeMember={removePolicyMember}
                loadingCreate={loadingUpdate}
                dataPolicy={data}
                refetch={refetchCurrent}
                dataStates={dataStates}
                dataCarriers={dataCarriers}
                loadingCarriers={loadingCarriers}
                updateZips={updateZips}
                tabsUpdate={tabsPolicy}
                onSwitchWithHolder={onSwitchWithHolder}
                canSwitchHolder={canShowSwitchHolder}
                category={category}
                policyId={id}
              />
            )}
            {tabs === 'Documents' && (
              <DocumentsTab
                refetch={loadDocuments}
                idPolicy={data.id}
                members={data.memberPolicySet.edges}
                documents={documents}
              />
            )}
            {tabs === 'Reminders' && <RemindersTab />}
            {tabs === 'Commissions' && data.id && (
              <CommissionsTab
                policyId={data.id}
                effectiveDate={data.effectiveDate}
                memberId={data.memberId}
                carrierId={data.carrier?.id}
                carrierName={data.carrier?.name}
                canNavigate={!!canViewCommissions}
              />
            )}
            {tabs === 'Activity' && <ActivityTab id={data.id} />}
            {tabs === 'Signature Forms' && (
              <div className='cardContainer'>
                <ConsentRequestTab
                  policyInfo={{
                    id: data.id,
                    user: data.user.id,
                    emailAddress: holderPolicy?.emailAddress,
                    phone: holderPolicy?.phone,
                  }}
                />
              </div>
            )}
            {tabs === 'Communications' && (
              <CommunicationsTab
                originModule={isQuote ? 'quotes' : 'policies'}
                originId={data.id}
                contactId={holderPolicy?.contact?.id}
                recipient={
                  holderPolicy
                    ? {
                        name: `${holderPolicy.firstName} ${holderPolicy.lastName}`,
                        phone: holderPolicy.phone,
                        email: holderPolicy.emailAddress,
                      }
                    : undefined
                }
                contextData={
                  isQuote
                    ? {quote: data, contact: holderPolicy?.contact}
                    : {policy: data, contact: holderPolicy?.contact}
                }
              />
            )}
            {tabs === 'Tickets' && data.id && <PolicyTicketsTab policyId={data.id} />}
            {tabs === 'ACA Verifications' && isACAPolicy && data.id && (
              <ACAVerificationsTab
                policyId={data.id}
                documentsDueDate={data.documentsDueDate}
                hasOpenTickets={hasOpenTickets}
                canAdd={!!canAddACAVerification}
                canChange={!!canChangeACAVerification}
                members={data.memberPolicySet.edges}
              />
            )}
          </Col>
        </Row>
      </div>

      {isOpenNotes && (
        <ModalNotes
          isOpen={isOpenNotes}
          onClose={onCloseNotes}
          idPolicy={data.id}
          onRefetchNotes={() => lastNoteRef.current?.refetchNotes()}
        />
      )}

      <Offcanvas show={show} onHide={() => setShow(false)}>
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <div className='kt-widget__content pt-0 m-0'>
            <PolicySummary
              assignAgent={onOpenAssignPolicy}
              changeSource={onOpenChangeSource}
              updateStatuses={onOpenStatuses}
              setTypeAssign={setTypeAssign}
              data={data}
              policy={`${id}`}
              isQuote={isQuote ? true : false}
              category={category}
            />
            <HolderInfoSide
              members={data.memberPolicySet.edges}
              memberId={data.memberId}
              zipCode={data.zipCode}
              stateName={data.stateEU?.name}
              stateCode={data.stateEU?.code}
              countyFips={data.countyFips || data.mailingCountyFips}
            />
          </div>
          <ListSectionSide
            sections={sections}
            tabs={tabs}
            setTabs={setTabs}
            lead={lead}
            onOpenNotes={onOpenNotes}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {isPolicy && isOpenCancel && data.id && (
        <ModalCancelPolicy
          id={data.id}
          isOpen={isOpenCancel}
          onClose={onCloseCancel}
          refetch={refetchCurrent}
        />
      )}
      {isPolicy && isOpenComplete && data.id && (
        <ModalCompletePolicy
          id={data.id}
          isOpen={isOpenComplete}
          onClose={onCloseComplete}
          refetch={refetchCurrent}
        />
      )}
      {isOpenMemberId && data.id && (
        <ModalMemberIdPolicy
          id={data.id}
          isOpen={isOpenMemberId}
          onClose={onCloseMemberId}
          refetch={refetchCurrent}
          memberId={data.memberId}
        />
      )}
      {(isPolicy || isQuote) && isOpenStatuses && data.id && (
        <ModalStatusesPolicy
          id={data.id}
          isOpen={isOpenStatuses}
          onClose={onCloseStatuses}
          refetch={refetchCurrent}
          statusPolicy={dataPoliciesStatuses}
          loadingPoliciesStatus={loadingPoliciesStatus}
          currentStatus={data.status}
          currentDocumentStatus={data.stateDocs}
          currentPaymentStatus={data.paymentStatus}
          currentDocumentsDueDate={data.documentsDueDate}
          isQuotePolicy={data.type === 'QUOTE'}
        />
      )}
      {isOpenDrawer && (
        <SelectPlansDrawer
          quoteData={quoteData}
          isOpen={isOpenDrawer}
          onClose={onCloseDrawer}
          onSelectPlan={handleSelectPlan}
        />
      )}
      {data.id && isOpenAssignPolicy && (
        <ModalAssignAgentPolicy
          id={data.id}
          isOpen={isOpenAssignPolicy}
          onClose={onCloseAssignPolicy}
          refetch={refetchCurrent}
          typeAssign={typeAssign}
        />
      )}
      {data.id && isOpenChangeSource && (
        <ModalChangeSourcePolicy
          id={data.id}
          isOpen={isOpenChangeSource}
          onClose={onCloseChangeSource}
          refetch={refetchCurrent}
          currentSourceId={data.leadSource?.id}
          currentSourceName={data.leadSource?.name}
        />
      )}
      {isOpenToPolicy && data.id && (
        <ModalToPolicy id={Number(data.id)} isOpen={isOpenToPolicy} onClose={onCloseToPolicy} />
      )}
      {isOpenDuplicate && data.id && (
        <ModalDuplicatePolicy
          id={data.id}
          isOpen={isOpenDuplicate}
          onClose={onCloseDuplicate}
          refetch={refetchCurrent}
        />
      )}
      <ModalACAVerification
        isOpen={isOpenACAVerification}
        onClose={onCloseACAVerification}
        policyId={data.id}
        documentsDueDate={data.documentsDueDate}
        hasOpenTickets={hasOpenTickets}
        canChange={!!canChangeACAVerification}
      />
    </div>
  )
}
